import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CustomizedTables, {Action } from '../../atoms/table';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Dialog from "../../atoms/dialog";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomizedDialogs from '../../atoms/dialog';
import { makeStyles } from '@material-ui/core/styles';
import ConfigurationJsonEditor from '../../atoms/jsonFormEditor/ConfigurationJsonEditor';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { handleSnackBar, invokePostService } from '../../../store/global/actions';
import axios from 'axios';
import config from '../../../config';
import { Alert } from '@material-ui/lab';
import { logError } from '../../../utils/logger';
import { validateIpOrDNS } from '../../../config/validations';

const API_URL = config.apiV2Url;

const useStyles = makeStyles((theme) => ({
    typography: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(5, 10, 5, 40),
    },

    textCapitalise: {
        textTransform: 'capitalize'
    }
}));



const SimulationConfiguration = () => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const [dialogBox, setDialogBox] = useState(false);
    const [action, setAction] = useState("");
    const [loading, setLoading] = useState(false)
    const [testLoading, setTestLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [editor, setEditor] = useState(null);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [configurationData, setConfigurationData] = useState([]);
    const [deleteSchema, setDeleteSchema] = useState(null);
    const [saving, setSaving] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [testing, setTesting] = useState(false)

    useEffect(() => {
        setLoading(true);
        getSimulationconfigurations();

    }, []);

    let schema = {
        // title: 'Create/Update Simulation Configuration',
        type: 'object',
        required: ['name', 'username', 'password', 'host', 'port', 'path'],
        options: {
            display: false,
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: {
            name: {
                title: 'Configuration Name',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 6
                },
            },
            username: {
                title: 'Username',
                type: 'string',
                format: 'email',
                options: {
                    layout: 'grid',
                    grid_columns: 6
                },
            },
            password: {
                title: 'Password',
                type: 'string',
                format: 'password',
                options: {
                    layout: 'grid',
                    grid_columns: 6
                },
            },
            sshkey: {
                title: 'PEM Key',
                type: 'string',
                format: 'textarea',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            host: {
                title: 'Hostname/IP Address',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 6
                },
            },
            port: {
                title: 'Port(SSH)',
                type: 'string',
                default: 22,
                options: {
                    layout: 'grid',
                    grid_columns: 6
                },
            },
            path: {
                title: 'Target Directory',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 6,
                },
            }
        },
        required: ["name", "username", "password"]
    }

    const defaultOptions = {
        theme: 'bootstrap4',
        iconlib: "fontawesome4",
        disable_collapse: true,
        compact: true,
        no_additional_properties: true,
        disable_edit_json: true,
        disable_properties: true,
        disable_add_remove: true,
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const options = {
        form_name_root: "simulationConfig",
        show_errors: "never"
    }

    const onChangeJsonEditor = (data) => {
        // For hide the the title
        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }
    }

    const dialogHandleClose = () => setDialogBox((prev) => !prev);

    const formatSimulationConfiguration = ({ name, username, password, host, port, path, sshkey }) => {
        return {
            name: name,
            type: "ssh",
            login: {
                username: username,
                password: password,
                host: host,
                port: port,
                path: path,
                privatekey: sshkey
            }
        }
    }

    const onSave = (data) => {
        setSaving(true)
        let configData = {}
        configData = formatSimulationConfiguration(data);

        if (action == "edit") {
            updateSimulationConfiguration(configData)
        } else {
            saveSimulationConfiguration(configData)
        }
    }

    const deleteSimulationConfiguration = async () => {
        try {
            if (deleteSchema) {
                const { _id } = deleteSchema;
                const response = await axios({
                    method: 'POST',
                    url: API_URL + `simulation-configuration/delete/${_id}`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })

                if (response.data?.status) {
                    dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
                    setDeleteSchema(null)
                    setDeleteLoader(false)
                    setOpen(false)
                    setLoading(true);
                    getSimulationconfigurations();
                }
            }


        } catch (err) {
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }))
        }
    }


    const saveSimulationConfiguration = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: API_URL + 'simulation-configuration/create',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: { data },
            })
            setSaving(false);
            if (response.data?.status) {
                dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
                setDialogBox(false);
                setLoading(true);
                getSimulationconfigurations();
            } else {
                if (response?.data?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    const errors = [{
                        path: options.form_name_root + ".name",
                        property: "format",
                        message: response?.data?.errors[0]?.message
                    }];
                    setErrorElementsInForm(errors)
                }
            }
        } catch (err) {
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }))
        }
    }

    const updateSimulationConfiguration = async (data) => {
        try {
            if (selectedConfig) {
                const { _id } = selectedConfig;
                const response = await axios({
                    method: 'POST',
                    url: API_URL + `simulation-configuration/update/${_id}`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: { data },
                })
                setSaving(false);
                if (response.data?.status) {
                    dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
                    setDialogBox(false);
                    setLoading(true)
                    getSimulationconfigurations();
                } else {
                    if (response?.data?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        const errors = [{
                            path: options.form_name_root + ".name",
                            property: "format",
                            message: response?.data?.errors[0]?.message
                        }];
                        setErrorElementsInForm(errors)
                    }
                }
            }


        } catch (err) {
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }))
        }
    }

    const getSimulationconfigurations = async (data) => {
        try {
            setLoading(true)
            const response = await axios({
                method: 'GET',
                url: API_URL + 'simulation-configuration/list',
                headers: {
                    'Content-Type': 'application/json',
                }
            })

            if (response.data?.status) {
                setConfigurationData(response.data.data)
                setLoading(false);
            }
        } catch (err) {
            console.error("Error: ", err)
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration data`, severity: 'error' }))
        }
    }

    const getSimulationConfigInformation = async (_id) => {
        try {
            if (_id === undefined || _id == null || _id == "") return

            const response = await axios({
                method: 'GET',
                url: API_URL + `simulation-configuration/${_id}`,
                headers: {
                    'Content-Type': 'application/json',
                }
            })

            if (response.data?.status) {
                const data = response.data?.data
                setSelectedConfig({
                    _id: data._id,
                    name: data.name,
                    username: data.login?.username,
                    password: data.login?.password,
                    host: data.login?.host,
                    port: data.login?.port,
                    path: data.login?.path,
                    sshkey: data.login?.privatekey ? data.login?.privatekey : "",
                })
                setFormLoading(false)
            }
        } catch (err) {
            console.error("Error: ", err)
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration data`, severity: 'error' }))
        }
    }

    const onSubmit = () => {
        const data = editor.getValue();

        const validateErrors = validateWithError(data)

        if (validateErrors.length) {
            setErrorElementsInForm(validateErrors)
            return
        }
        onSave(data)
    }

    const setErrorElementsInForm = (validationErrors) => {

        validationErrors.forEach(error => {
            let path = error.path.split('.')

            let elementName = `${path[0]}[${path[1]}]`

            let ele = document.getElementById(elementName)
            let errorElement = `<p id="validation-error-${error.path}" class="text text-danger simulationConfig-validation-error" style="font-family: Roboto,Helvetica;">${error.message}</p>`
            ele.insertAdjacentHTML("afterend", errorElement)
        })
    }

    const validateWithError = ({ name, username, password, host, path, port, sshkey }) => {
        clearErrors()
        let errors = []
        try {

        let prefix = options.form_name_root + "."
        if (name === "") {
            errors.push({
                path: prefix + "name",
                property: "format",
                message: "Name required"
            })
        }

        if (username === "") {
            errors.push({
                path: prefix + "username",
                property: "format",
                message: "Username cannot be empty"
            })
        }

        if (password === "" && sshkey === "") {
            errors.push({
                path: prefix + "password",
                property: "format",
                message: "Password or PEM key is required"
            })
        }

   
        if (host === "") {
            errors.push({
                path: prefix + "host",
                property: "format",
                message: "Hostname/IP Address cannot be empty"
            })
        }else{
            if(!validateIpOrDNS(host)){
                errors.push({
                    path: prefix + "host",
                    property: "format",
                    message: "Hostname/IP Address is invalid"
                })
            }
        }

        if (port === "") {
            errors.push({
                path: prefix + "port",
                property: "format",
                message: "Port cannot be empty"
            })
        }

        if (path === "") {
            errors.push({
                path: prefix + "path",
                property: "format",
                message: "Path cannot be empty"
            })
        }

        return errors;

        } catch (error) {
            console.error(`Validating simulation config data failed. ${error.message}`);
            return errors;
        }
    }

    const clearErrors = () => {
        const errorDivs = document.querySelectorAll(".simulationConfig-validation-error");

        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }
    }

    const onClear = () => {
        setSelectedConfig({
            name: "",
            username: "",
            password: "",
            host: "",
            port: "",
            path: "",
            sshkey: ""
        })
    }


    const addSimulationConfig = () => {
        setDialogBox(true)
        setAction("add")
        setSelectedConfig(null);
    }

    const deleteData = (data) => {
        setOpen(true)
        setDeleteSchema(data)
    }

    const handleDelete = () => {
        setDeleteLoader(true)
        deleteSimulationConfiguration()
    }

    const  isValidPrivateKey = (key)  => {
        key = key.trim();
      
        const openSshHeader = "-----BEGIN OPENSSH PRIVATE KEY-----";
        const openSshFooter = "-----END OPENSSH PRIVATE KEY-----";
        const rsaHeader = "-----BEGIN RSA PRIVATE KEY-----";
        const rsaFooter = "-----END RSA PRIVATE KEY-----";
      
        const isOpenSSH = key.startsWith(openSshHeader) && key.endsWith(openSshFooter);
        const isRSA = key.startsWith(rsaHeader) && key.endsWith(rsaFooter);
      
        if (!isOpenSSH && !isRSA) {
          return { valid: false, error: "Invalid key format. Check BEGIN/END headers." };
        }
      
        const keyBody = key.replace(openSshHeader, "").replace(openSshFooter, "")
                           .replace(rsaHeader, "").replace(rsaFooter, "").trim();
      
        const base64Regex = /^[A-Za-z0-9+/=\s]+$/;
        if (!base64Regex.test(keyBody)) {
          return { valid: false, error: "Invalid key format. Key content is not valid Base64." };
        }
      
        return { valid: true };
      }
      

    /** Test configuration */
    const testConfiguration = () => {
        const data = editor.getValue();
        const validateErrors = validateWithError(data)

        if (validateErrors.length) {
            setErrorElementsInForm(validateErrors)
            return
        }


        setTesting(true)

        if(data.sshkey != undefined && data.sshkey != "") {
            const keyValidity = isValidPrivateKey(data.sshkey)
            if(keyValidity != undefined && !keyValidity.valid ){
                setTesting(false)
                if(keyValidity.error) dispatch(handleSnackBar({ open: true, message: keyValidity.error, severity:  'error' }));
                return
            }
        }

        console.log("TEstttttt")
        dispatch(invokePostService('testSimulationConfig', data)).then(response => {
            setTesting(false)
            dispatch(handleSnackBar({ open: true, message: response.message, severity: response.status ? 'success' : 'error' }));
        })
    }

    return (
        <Grid container direction="row" spacing={2}>

            <CustomizedDialogs
                open={open}
                title="Delete"
                handleClose={() => setOpen(false)}
                actions={
                    <React.Fragment>
                        <Button autoFocus onClick={() => setOpen(false)} variant="outlined" color="primary">
                            Cancel
                        </Button>
                        <Button autoFocus variant="contained" color="secondary" onClick={handleDelete} disabled={deleteLoader} startIcon={deleteLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />}>
                            {deleteLoader ? "Deleting.." : "Delete"}
                        </Button>
                    </React.Fragment>
                }>
                <Typography>Do you want to delete the simulation configuration?</Typography>
            </CustomizedDialogs>

            <Grid container direction="row" alignItems="center" justify="center" style={{ padding: 10, justifyContent: 'end' }}>
                <Button id="addNewSimulationConfig" onClick={() => addSimulationConfig()} variant="contained" className={classes.textCapitalise} > Add New Simulation Configuration </Button>
            </Grid>

            <Grid item xs={12}>
                <SimulationConfigurationTable getSimulationConfig={getSimulationConfigInformation} configurationData={configurationData} deleteData={deleteData} dialogBox={setDialogBox} action={setAction} dispatch={dispatch} loading={loading} toggleLoading={setFormLoading} />
            </Grid>

            <Grid item xs={12}>
                {dialogBox && (

                    <Dialog
                        title={action === "add" ? "Add Simulation Configuration" : "Edit Simulation Configuration"}
                        handleClose={dialogHandleClose}
                        open={true}
                        paperProps={{ id: "addSimulationConfigModal" }}

                        actions={
                            <>
                                <Button onClick={() => onClear()} color="primary" variant="outlined" style={{ marginRight: 10 }} className={classes.textCapitalise}>
                                    Clear
                                </Button>
                                <Button id={'test-simulation-config'} onClick={() => testConfiguration()} disabled={testing} type="submit" color="primary" variant="contained" className={classes.textCapitalise}>
                                    Test Configuration
                                </Button>
                                <Button onClick={() => onSubmit()} disabled={saving} type="submit" color="primary" variant="contained" className={classes.textCapitalise} id={"saveSimulationConfig"}>
                                    Save
                                </Button>
                            </>
                        }
                    >
                        <Grid container direction="row" style={{ padding: '0.5rem' }} spacing={2}>
                            <Alert severity='info' icon={false} style={{ width: '99%' }}>These credentials are for SSH login to the deployment machine</Alert>
                            {formLoading ?
                                <LoaderWithProgress size={20} isContent={true} styleRoot={{ height: '28vh', width: '100%' }} />
                                :
                                <ConfigurationJsonEditor setEditor={setEditor} options={options} defaultOptions={defaultOptions} schema={schema} schemaValues={selectedConfig} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="json_simulationconfig_editor" />
                            }
                        </Grid>
                    </Dialog>
                )}

            </Grid>
        </Grid>
    )
}
export default SimulationConfiguration;



const headers = [
    { label: 'Configuration', name: 'name' },
    { label: 'Type', name: 'type' },
    { label: 'Username', name: 'username' },
    { label: 'Host', name: 'host' },
    { label: 'Port', name: 'port' },
    { label: 'Path', name: 'path' },
];

const SimulationConfigurationTable = ({ configurationData = [], getSimulationConfig, deleteData, dialogBox, action, loading, toggleLoading }) => {

    const onMenuClick = (data) => (key) => {

        switch (key) {
            case 'edit':
                dialogBox(true)
                toggleLoading(true)
                action("edit")
                getSimulationConfig(data?._id);
                break;

            case 'delete':
                deleteData(data);
                break;
        }
    };
    return (
        <CustomizedTables size="small" headers={headers} actions id={"simulationConfigTable"}>
            {
                loading ?
                    <StyledTableRow>
                        <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
                            Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                        </StyledTableCell>
                    </StyledTableRow>
                    : configurationData.length < 1 ?
                        <StyledTableRow>
                            <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
                                No simulation configurations available.
                            </StyledTableCell>
                        </StyledTableRow> : configurationData.map((item, index) => {

                            return (
                                <StyledTableRow>
                                    <StyledTableCell align={'left'}>{item.name || ''}</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.type || ''}</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.login?.username || ''}</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.login?.host || ''}</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.login?.port || ''}</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.login?.path || ''}</StyledTableCell>
                                    <Action onMenuClick={onMenuClick(item)} showCloneBtn={false} index={index} />
                                </StyledTableRow>
                            );
                        })
            }
        </CustomizedTables>
    )
};